import React from "react";
import NosMetiersHeader from "./NosMetiersHeader";
import NosMetiersPage from "./NosMetiersPage";
import Footer from "../../components/Footer";
const NosMetiers = () => {
  return (
    <div className="nos-metiers">
      {/* Titre principal */}
      <header className="nos-metiers-header">
       <NosMetiersHeader />
      </header>
      <NosMetiersPage />
      <Footer />


    </div>
  );
};

export default NosMetiers;
